import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findOpcaoConsultaLote from '../../service/findOpcaoConsultaLote';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';




export default function OpcaoConsultaLoteList({onEdit}:{onEdit:(opcaoConsultaLote:any)=>void}) {
  const { t } = useTranslation();
  const [opcoes, setOpcaes] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: 'nome',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const loadLazyData = () => {
    findOpcaoConsultaLote(lazyState).then(data => {setTotalRecords(data.total);setOpcaes(data.opcoes)}).catch(() => {setTotalRecords(0);setOpcaes(undefined)});
  }

  const editBodyTemplate = (item:any) => {
    return <Button icon="pi pi-pencil" onClick={() => onEdit(item)} style={{background:'transparent', color:'gray', border: 'none'}} />;
  };
  
  useEffect(() => {
    loadLazyData();
  },[lazyState])

  return (
    <div>
      <div>
        <DataTable value={opcoes} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           
           <Column field="nome" sortable header={t('nome')}  />
           <Column body={editBodyTemplate} />
        </DataTable> 
      </div>
    </div>
  )
}


